import Resultat from './Resultat.js'


export default class Tache {

    id='' // clef primaire
    level=''
    parent=''
    type='TASK'  //TASK OU DIAL(OGUE)
    position=[]
    requis=[]
    data={
        reload:0,
        label:"TACHE", //Si dialogue le label = id de l'element locuteur
        locuteur:"",
        description:'Description en attente...',
        editee:0,
        todo:0
    }



    constructor(label,level,parent,type,pos) {

        this.id="T"+Date.now()
        this.level=level
        this.parent=parent
        this.type=type
        this.position=pos
        this.data.label=label

    }


}